// extracted by mini-css-extract-plugin
module.exports = {"share-links":"ShareButtons_share-links__26JLW","facebook":"ShareButtons_facebook__1FjUM","twitter":"ShareButtons_twitter__2iy9X"};